import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Link } from "react-router"
import AvatarUser from "@/components/base/AvatarUser"
import AvatarView from "@/components/base/AvatarView"

interface ScenarioSettingsMenuProps {
  children: React.ReactNode
}

function ScenarioSettingsMenu(props: ScenarioSettingsMenuProps) {
  const snap = useSnapshot(store)

  return (
    <DropdownMenu >
      <DropdownMenuTrigger className="rounded-full" asChild>
        {props.children}
      </DropdownMenuTrigger>
      {/* <DropdownMenuContent className="w-95 p-0"> */}
      <DropdownMenuContent className="mt-4 w-xs p-3 z-[9999]">
        {/* <Link
          to={{
            hash: "#settings/account",
          }}
        >
          <DropdownMenuItem>Settings</DropdownMenuItem>
        </Link> */}
        {/* <DropdownMenuItem>Help & Feedback</DropdownMenuItem> */}
        <Link
          to={{
            hash: "#settings/credentials",
          }}
        >
          <DropdownMenuItem className="text-md h-11 font-semibold text-sm">
            <IconHugeiconsFingerAccess className="size-5.5 mr-2 text-fg" />
            Credentials
          </DropdownMenuItem>
        </Link>
        <DropdownMenuItem className="text-md h-11 font-semibold text-sm">
          <IconHugeiconsMoon02 className="size-5.5 mr-2 text-fg" />
          Dark mode
        </DropdownMenuItem>
        {/* <DropdownMenuItem onClick={() => store.session.actions.logout()}>Sign Out</DropdownMenuItem> */}
        {/* <div className="fc w-full flex-col gap-2 rounded-t-2xl p-6 shadow">
          <Link to="/settings/account" className="group relative">
            <AvatarView name={snap.session.user?.name || ""} src={snap.session.user?.image || ""} className="size-21" />
          </Link>
          <div className="fc flex-col text-center leading-2">
            <span className="truncate text-xl">Hi, {snap.session.user?.name}!</span>
            <span className="-mt-0.5 truncate text-sm text-fg-secondary">{snap.session.user?.email}</span>
          </div>
        </div>
        <DropdownMenuGroup className="p-2">
          <DropdownMenuItem className="text-md h-11">
            <IconHugeiconsSettings02 className="size-5" />
            Settings
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="text-md h-11">
            <IconHugeiconsLogout01 className="size-5" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuGroup> */}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ScenarioSettingsMenu
